module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('my-header'), _vm._v(" "), _c('keep-alive', [_c('router-view')], 1), _vm._v(" "), _c('controller', {
    ref: "controller",
    attrs: {
      "song": _vm.song,
      "playState": _vm.playState
    }
  }), _vm._v(" "), _c('song', {
    ref: "song",
    attrs: {
      "song": _vm.song,
      "playState": _vm.playState,
      "show": _vm.songShow
    }
  }), _vm._v(" "), _c('playList')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-09ee97f4"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/view/home.vue
// module id = 193
// module chunks = 1